export default __webpack_public_path__ + "static/media/logo-mapfre.2393ad40.svg";